import styled from "@emotion/styled";
import type { Theme } from "@emotion/react";

export const ChatMain = styled.main<{ withoutBotPadding?: boolean }>`
  ${({ theme }: { theme: Theme }) => theme.structures.Page}
  ${({ withoutBotPadding }) => (withoutBotPadding ? "padding-bottom: 0;" : "")}

  align-items: center;
  padding: 24px 16px;

  @media screen and (min-width: 1280px) {
    padding: 24px 32px;
  }
  @media ${({ theme }: { theme: Theme }) => theme.medias.mobile} {
    padding: 0;
    padding-bottom: 0;
    /* -webkit-fill-available resolve para 0 no WebKit (Safari/iOS) e some com o chat; 100dvh resolve certo. ANCR-5408 */
    min-height: 100vh;
    min-height: 100dvh;
    overflow: hidden;
  }
`;

export const ChatCard = styled.div`
  display: flex;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 1px 2px rgba(46, 45, 55, 0.12);
  position: relative;
  width: 100%;
  max-width: 1296px;

  @media ${({ theme }: { theme: Theme }) => theme.medias.desktop} {
    height: calc(100vh - 111px);
  }
  @media ${({ theme }: { theme: Theme }) => theme.medias.mobile} {
    border-radius: 0;
    flex-wrap: wrap;
  }
`;
